var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/AuthErrorPage/index.tsx";
import React from 'react';
import { Text, VStack } from '@adc/parallax-component-library';
import { usePartner } from 'Hooks';
import { Main } from 'Components/utility/Main';
import i18n from 'Utilities/i18n';
import { LogoActionBar } from '../ActionBar';
const AuthErrorPage = () => {
  const {
    partner
  } = usePartner();
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LogoActionBar, {
    testID: "ErrorPage",
    noActionButton: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    padding: "$4",
    backgroundColor: "$surface.background",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    zIndex: 1,
    style: {
      height: '100vh',
      width: '100vw'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ErrorPage.errorLoading-title",
    marginBottom: "$2",
    color: "$text.100",
    fontWeight: "$h3.strong",
    fontSize: "$h3.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 9
    }
  }, i18n.t('Global.modals.errorLoading.title')), /*#__PURE__*/React.createElement(Text, {
    testID: "ErrorPage.errorLoading-body",
    color: "$text.100",
    fontWeight: "$bodyBase.default",
    fontSize: "$bodyBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 9
    }
  }, i18n.t('Global.modals.errorLoading.body', {
    partnerName: partner.displayName
  }))));
};
export default AuthErrorPage;